import { DateTime } from 'luxon'

export default class Dashboard {
  static groupEarningsByMonth (data) {
    return data.reduce ((acc, curr) => {
      const month = DateTime.fromISO (curr.date).setLocale ('pt-BR').toFormat ('MMM yyyy')
      if (!acc[month]) {
        acc[month] = []
      }
      acc[month].push (curr)
      return acc
    }, {})
  }

  static getEarningsByPaymentMethod (earnings, paymentMethod) {
    return earnings.filter (e => e.type === 'bill').reduce ((total, bill) => (
      total + bill.payments.reduce ((total, payment) => (
        total + (payment.payment_method.codename === paymentMethod.codename ? payment.value : 0)
      ), 0)
    ), 0)
  }
}